/* TS 商品橫排 —— 新品／熱銷 的切換。

   沒有 JS 的時候：所有卡片都看得見、分頁點了沒反應，但頁面不會壞。
   這是刻意的——商品清單本來就該在 HTML 裡，不靠 JS 才長得出來（SEO 與爬蟲都看得到）。

   每個區塊各自獨立，同一頁放兩個也不會互相干擾。
   <script src> 每出現一次就會執行一次，所以要用旗標擋住重複初始化。 */
if (!window.__tsShowcaseInit) {
  window.__tsShowcaseInit = 1;
  (function () {

    function setup(root) {
      if (root.__ts) return;
      root.__ts = 1;

      var track = root.querySelector('.ts-showcase__track');
      if (!track) return;
      var cards = [].slice.call(track.querySelectorAll('.ts-card'));
      var tabs = [].slice.call(root.querySelectorAll('.ts-showcase__tabs button'));
      if (!tabs.length) return;

      function apply(name) {
        cards.forEach(function (c) {
          // data-tab="*" 是「兩頁都出現」，任何分頁都要顯示
          var t = c.dataset.tab;
          c.hidden = !(t === '*' || t === name);
        });
        // 切換之後捲回最左邊，不然會停在上一頁滑到一半的位置
        root.querySelector('.ts-showcase__rail').scrollLeft = 0;
      }

      tabs.forEach(function (b) {
        b.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          apply(b.dataset.tab);
        });
      });

      var on = tabs.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      apply((on || tabs[0]).dataset.tab);
    }

    function boot() { document.querySelectorAll('.ts-showcase').forEach(setup); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // 佈景主題編輯器裡新增／搬動區塊時會重新塞 DOM，要重新接一次
    document.addEventListener('shopify:section:load', boot);
    // 在後台點某一個商品方塊時，如果它剛好被分頁藏起來，先讓它現形
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest ? e.target.closest('.ts-card') : null;
      if (card && card.hidden) card.hidden = false;
    });
  })();
}
